import { render, staticRenderFns } from "./Conciergerie.vue?vue&type=template&id=024bbef7"
import script from "./Conciergerie.vue?vue&type=script&lang=js"
export * from "./Conciergerie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024bbef7')) {
      api.createRecord('024bbef7', component.options)
    } else {
      api.reload('024bbef7', component.options)
    }
    module.hot.accept("./Conciergerie.vue?vue&type=template&id=024bbef7", function () {
      api.rerender('024bbef7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/Conciergerie.vue"
export default component.exports